import React from 'react';
import { Typography, AccordionSummary } from '../../../../base';
import { IInterviewQuestion } from '../../../../common';
import {
    StyledAccordion,
    StyledAccordionDetails,
} from './InterviewQuestionItem.styles';

interface Props {
    question: IInterviewQuestion;
    index: number;
    expanded: number | false;
    onChange: (
        panel: number
    ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const InterviewQuestionItem = (props: Props) => {
    const { question, index, expanded, onChange } = props;

    return (
        <StyledAccordion
            key={question.id}
            disableGutters
            expanded={expanded === index}
            onChange={onChange(index)}
        >
            <AccordionSummary>
                <Typography variant="subtitle1">{question.question}</Typography>
            </AccordionSummary>
            <StyledAccordionDetails>
                <Typography variant="body2">{question.guidelines}</Typography>
            </StyledAccordionDetails>
        </StyledAccordion>
    );
};

export default InterviewQuestionItem;
